import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddYogurtType({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  return (
    <Modal
      className="modal addType_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add New Yogurt Type</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">

            <div className="control_group">
              <label htmlFor="type-name">Type Name</label>
              <TextField
                id="type-name"
                placeholder="e.g., Frozen Greek Yogurt, Classic Greek Yogurt"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group">
              <label htmlFor="reject-reason">Pricing Method</label>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel value="1" control={<Radio />} label={
                  <>
                    <strong>Per 100g Pricing</strong>
                    <span>Price is calculated based on weight (per 100 grams)</span>
                  </>
                } />
                <FormControlLabel value="2" control={<Radio />} label={
                  <>
                    <strong>Size-wise Pricing</strong>
                    <span>Fixed prices for Small, Medium, and Large sizes</span>
                  </>
                } />
                {/* <FormControlLabel value="3" control={<Radio />} label={
                  <>
                    <strong>Greek Bowl Pricing</strong>
                  </>
                } /> */}
              </RadioGroup>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Add Type
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
